// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__eiip7","title":"card_title__3hrhG","inActive":"card_inActive__1cNDa"};